import React from 'react'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'
import { prefixer } from 'stylis'
import rtlPlugin from 'stylis-plugin-rtl'
import { useSelector } from 'react-redux'
import { selectThemeMode, selectDirection } from '@store/slices/uiSlice'
import { lightTheme, darkTheme } from './index.js'

// RTL cache
const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
})

const cacheLtr = createCache({
  key: 'muiltr',
})

export const ThemeProvider = ({ children }) => {
  const themeMode = useSelector(selectThemeMode)
  const direction = useSelector(selectDirection)
  
  const theme = themeMode === 'dark' ? darkTheme : lightTheme
  const cache = direction === 'rtl' ? cacheRtl : cacheLtr

  return (
    <CacheProvider value={cache}>
      <MuiThemeProvider theme={theme}>
        {children}
      </MuiThemeProvider>
    </CacheProvider>
  )
}
